import React from 'react';
import { motion } from 'framer-motion';
import { reviewActions, workflowSteps } from '../../data/semanticKnowledge';
import { fadeUp } from '../../utils/motion';
export function SkpWorkflow() {
  return <section id="how-it-works" className="scroll-mt-20 bg-white py-20 lg:py-28" data-id="element-1404" data-mp="2xc0c36u3negl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1405" data-mp="2sdyqae5ah11f">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-14" data-id="element-1406" data-mp="2sbkzwilk0d07">
          <h2 className="lg:col-span-4 font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight" data-id="element-1407" data-mp="2nchrqpaa1qo0">
            How the platform works
          </h2>
          <p className="lg:col-span-8 text-xl text-ink-muted leading-relaxed lg:pt-2" data-id="element-1408" data-mp="2eefwkqd85s8n">
            Four stages carry a document from source material to approved,
            searchable knowledge.
          </p>
        </motion.div>

        <ol className="border-b border-line" data-id="element-1409" data-mp="ck6u4e3bmxoo">
          {workflowSteps.map(step => <motion.li key={step.number} {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 border-t border-line py-12" data-id="element-1410" data-mp="7ldfgicat0mx">
              <div className="lg:col-span-4 flex gap-5" data-id="element-1411" data-mp="177uk22mj4fqd">
                <span className="font-heading font-extrabold text-5xl text-teal leading-none w-10 shrink-0" data-id="element-1412" data-mp="tb7mpyqnznjx">
                  {step.number}
                </span>
                <div data-id="element-1413" data-mp="1lyv4z74gq23e">
                  <h3 className="font-heading font-bold text-2xl text-ink-dark mb-4" data-id="element-1414" data-mp="1lyl9j40nf2qb">
                    {step.title}
                  </h3>
                  <ul className="flex flex-wrap gap-2" aria-label="Tools used" data-id="element-1415" data-mp="1qx4wn7qzakk9">
                    {step.tools.map(tool => <li key={tool} className="text-xs font-medium text-navy bg-surface-muted border border-line rounded px-2 py-1" data-id="element-1416" data-mp="1h84w3jwtvh3y">
                        {tool}
                      </li>)}
                  </ul>
                </div>
              </div>

              <div className="lg:col-span-8" data-id="element-1417" data-mp="2jj3dwdp33zwq">
                <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1418" data-mp="2elbj9bx21zou">{step.body}</p>

                {step.note && <p className="mt-6 border-l-2 border-green-soft pl-5 text-base text-ink-dark leading-relaxed" data-id="element-1419" data-mp="29lp5n1dbehfi">
                    {step.note}
                  </p>}

                {step.number === '3' && <div className="mt-6 bg-surface-muted rounded-lg p-6" data-id="element-1420" data-mp="20mbv05dgfmt7">
                    <p className="text-ink-dark font-semibold mb-1" data-id="element-1421" data-mp="1vuk39rikbb1h">
                      AI proposals remain proposals until approved.
                    </p>
                    <p className="text-ink-muted mb-4" data-id="element-1422" data-mp="1qte87n1fjbos">Reviewers can:</p>
                    <ul className="flex flex-wrap gap-2" data-id="element-1423" data-mp="1ly8psy78kf5g">
                      {reviewActions.map(action => <li key={action} className="text-sm font-medium text-ink-dark bg-white border border-line rounded-md px-3 py-1.5" data-id="element-1424" data-mp="1hx58e79jib24">
                          {action}
                        </li>)}
                    </ul>
                  </div>}
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}